module.exports = __webpack_public_path__ + "static/img/medal2.4a713d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/7/medal2.png
// module id = AtFm
// module chunks = 1